import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_need_to_release_wrkrs_to_be_available_for_governme'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_need_to_release_wrkrs_to_be_available_for_governme',
  name: 'Does the facility need to release workers to be available for government-mandated forced labor?',
  description:
    'The intent of this question is to understand if the facility releases workers to be available for government mandated forced labor or state-imposed forced labor. \r\r\n\r\r\n"Government mandated forced labor" refers to compulsory labor that provides income to the government and related enterprises, such as domestic cotton harvesting or government-contracted labor in foreign countries. Excludes military service, work in case of emergencies and minor communal services.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fl-6',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 5100,
  sectionId: '2.2.7',
  impactArea: 'Forced Labour',
  impactAreaId: 'FORCED_LABOUR',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
